export default {
  Required: 0, // bắt buộc
}
